import { render, staticRenderFns } from "./ModalFee.vue?vue&type=template&id=eb4ba044&scoped=true&"
import script from "./ModalFee.vue?vue&type=script&lang=js&"
export * from "./ModalFee.vue?vue&type=script&lang=js&"
import style0 from "./ModalFee.vue?vue&type=style&index=0&id=eb4ba044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4ba044",
  null
  
)

export default component.exports